<script lang="ts">
    import { cn } from "@/lib/utils";
    import BannerHeader from "./BannerHeader.svelte";
    import type { ComponentProps } from "svelte";

    interface $$Props extends ComponentProps<BannerHeader> {

    }
    let className: string = ""
    export {className as class}
</script>

<!-- NOTE:
    <slot name="banner" slot="banner"> 
    doesn't forward the default from BannerHeader so new default is required. 
-->
<BannerHeader class={cn(className)} {...$$restProps}>
    <slot name="header" slot="header"/>
    <slot name="banner" slot="banner">
        <div class="header-background w-full h-full rounded-t" />
    </slot>
    <div slot="body">
        <slot name="body"/>
        <div class="sticky bottom-0 z-20">
            <slot name="sticky"/>
        </div>
    </div> 
</BannerHeader>

<style lang="scss">

    .header-background {
        background: linear-gradient(0deg, rgba(var(--rgb-xert-teal), 0.75) 0%, rgba(var(--rgb-xert-teal), 0.75) 100%), url("../../assets/images/Hero-Carousel-4-bg.jpg");
        background-position: top right;
    }

</style>